// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__1vMF+","syncButton":"styles_syncButton__aDOlT","ignoreButton":"styles_ignoreButton__vmvSn"};